import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import SuperAdminHome from "./pages/SuperAdminHome";
import Organizations from "./pages/Organizations";
import Clients from "./pages/Clients";
import BillingPage from "./pages/Billing";
import Resources from "./pages/Resources";
import CreateOrganization from "./pages/CreateOrganization";
import Settings from "./pages/Settings";
import Prompts from "./pages/Prompts";
import OtsPipelines from "./pages/OtsPipelines";
import NotAuthorized from "./pages/NotAuthorized";
import RequireSuperAdmin from "./auth/RequireSuperAdmin";
import AuthCallback from "./auth/callback";
import LoginPage from "./auth/LoginPage";

import { OnboardingProvider } from "./context/OnboardingContext";
import OnboardingRouter from "./onboarding/OnboardingRouter";
import RegistrationComplete from "./onboarding/RegistrationComplete";
import Billing from "./onboarding/Billing";
import Finalize from "./onboarding/Finalize";

function App() {
  return (
    <Router>
      <Routes>

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/auth/login" replace />} />

        {/* Public callback route */}
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Admin portal routes */}
        <Route
          path="/super-admin"
          element={
            <RequireSuperAdmin>
              <Layout><SuperAdminHome /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/organizations"
          element={
            <RequireSuperAdmin>
              <Layout><Organizations /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/clients"
          element={
            <RequireSuperAdmin>
              <Layout><Clients /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/billing"
          element={
            <RequireSuperAdmin>
              <Layout><BillingPage /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/resources"
          element={
            <RequireSuperAdmin>
              <Layout><Resources /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/create-organization"
          element={
            <RequireSuperAdmin>
              <Layout><CreateOrganization /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/settings"
          element={
            <RequireSuperAdmin>
              <Layout><Settings /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/prompts"
          element={
            <RequireSuperAdmin>
              <Layout><Prompts /></Layout>
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/super-admin/ots"
          element={
            <RequireSuperAdmin>
              <Layout><OtsPipelines /></Layout>
            </RequireSuperAdmin>
          }
        />

        {/* Not authorized */}
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route path="/auth/login" element={<LoginPage />} />

        {/* ⭐ Onboarding route (public) */}
        <Route
          path="/org-register"
          element={
            <OnboardingProvider>
              <OnboardingRouter />
            </OnboardingProvider>
          }
        />

        {/* Fallback */}
        <Route
          path="*"
          element={
            <Layout>
              <h2>CloudGenomics Super Admin Portal</h2>
              <p>Select a page from the navigation.</p>
            </Layout>
          }
        />
        <Route
          path="/org-register/complete"
          element={
            <OnboardingProvider>
              <RegistrationComplete />
            </OnboardingProvider>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;